import { Button, CheckIcon, ChevronLeftIcon, ConsentOrdersPathName, Modal, useNames } from "@fla/components";
import { withConsentOrder } from "components/HOCs/withConsentOrder";
import { useConsentOrders } from "hooks/ConsentOrders";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { selectConsentOrdersBase } from "..";

function Submit() {
  const { submitConsentOrder, setShowSuccessModal, showSuccessModal, isSubmitting } = useConsentOrders();

  const navigation = useNavigate();

  const closeModal = () => {
    setShowSuccessModal(false);
    navigation(ConsentOrdersPathName.Default);
  };

  const goBack = () => {
    navigation(ConsentOrdersPathName.Summary);
  };

  const { initialDetails } = useSelector(selectConsentOrdersBase);
  const { spouseFirstName } = useNames({ initialDetails });

  return (
    <section className="w-full md:max-w-2xl h-fit mx-auto my-10">
      <div className="md:bg-white rounded-xl w-full h-fit px-10 md:py-5 md:shadow-md mx-auto md:my-7">
        <h3 className="text-center">Submit</h3>

        <p className="mt-5">
          This is the final step before submitting your information to our legal team.
          <br />
          <br />
          Once you click on the Submit button, all of the information you have provided will be sent to our legal team
          for review. Our team will use this information to draft your consent order documents.
          <br />
          <br />
          Please ensure that you have double-checked all of the information you have provided and that it is accurate
          and complete before submitting.
          <br />
          <br />
          Please contact {spouseFirstName} if you're not sure of any information relating to {spouseFirstName}.
          <br />
          <br />
          After we receive your submission, our team will be in touch with you shortly to discuss the next steps in the
          process.
        </p>

        <div className="flex justify-between items-center w-full mt-16">
          <button
            className="text-gray-500 font-semibold hover:text-gray-600 flex items-center justify-center space-x-1 group"
            onClick={goBack}
          >
            <ChevronLeftIcon strokeColor="group-hover:text-gray-600" classes="w-3.5 h-3.5" />
            <span>Back</span>
          </button>

          <Button
            type="button"
            isSubmitting={isSubmitting}
            className="w-40 h-10 px-12 flex justify-center items-center"
            onClick={submitConsentOrder}
          >
            Submit
          </Button>
        </div>
      </div>

      <Modal isOpen={showSuccessModal} closeModal={closeModal} hideCloseBtn>
        <CheckIcon width={60} height={60} classes="mx-auto block fill-current text-green-600" />
        <p className="mt-5 text-center px-5">Your Consent Orders information has been submitted successfully.</p>

        <Button onClick={closeModal} className="px-7 py-2 block mx-auto mt-7">
          Done
        </Button>
      </Modal>
    </section>
  );
}
export default withConsentOrder(Submit);
